export const cafeConfiguration: AppConfiguration = {
    isMarket: false,
    imageThemeID: "Cafe"
}

export const marketConfiguration: AppConfiguration = {
    isMarket: true,
    imageThemeID: "MK"
}
